import { Observed } from './observed';

type InViewTrackingProps = {
  onEnter?: () => void;
  onLeave?: () => void;
  renderAs?: React.ElementType;
  className?: string;
};

/**
 * @deprecated Use `import { useInView } from 'react-intersection-observer';` instead, see: https://brewery.xing.io/in-viewport-tracking
 */
const InViewTracking: React.FC<
  React.PropsWithChildren<InViewTrackingProps>
> = ({ onEnter, onLeave, children, ...props }) => {
  return (
    <Observed
      {...props}
      onEnter={() => {
        if (onEnter) onEnter();
      }}
      onLeave={() => {
        if (onLeave) onLeave();
      }}
    >
      {children}
    </Observed>
  );
};

export { InViewTracking };
